import React from 'react';

import Splash from '../../pages/splash';
import NpsSurveyContainer from '../NpsSurveyModal/NpsSurveyContainer';
import usePostLoginModal from '../../hooks/usePostLoginModal';

const AuthLayout: React.FC = ({ children }) => {
  const { modal, closeModal } = usePostLoginModal();

  return (
    <>
      {children}

      {modal?.type === 'nps' && (
        <NpsSurveyContainer eligibility={modal.eligibility} onClose={closeModal} />
      )}

      {modal?.type === 'splash' && (
        <Splash splash={modal.splash} onClose={closeModal} />
      )}
    </>
  );
};

export default AuthLayout;
